// extracted by mini-css-extract-plugin
export default {"checkbox_checked":"AddToDo_checkbox_checked__bK3l0","Mui-checked":"AddToDo_Mui-checked__mkyDb","dropdownMenu":"AddToDo_dropdownMenu__0WIPl"};